import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import type { TripadvisorTestimonyProps } from 'Components/widgets/tripadvisor-testimony/TripadvisorTestimony';
import { TripadvisorTestimony } from 'Components/widgets/tripadvisor-testimony/TripadvisorTestimony';
import { Slider } from 'Components/frameworks/slider/Slider';
type Props = {
  className?: string;
  items: Array<Partial<TripadvisorTestimonyProps>>;
};
export const TripadvisorTestimonies = ({ className, items }: Props) => {
  const { isTablet } = useResponsive();

  if (!items?.length) {
    return null;
  }

  if (items.length === 1) {
    return <TripadvisorTestimony {...items[0]} className={className} />;
  }

  return (
    <Slider
      className={className}
      cols={isTablet ? 1 : 0}
      hasControls={isTablet}
      navPosition="center"
      nextLabel={t('common.next')}
      previousLabel={t('common.previous')}
      scrollAreaClassName="flex overflow-hidden"
      scrollAreaContainerClassName="overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory"
      scrollItemClassName={(i) =>
        classnames('max-w-full flex-none overflow-hidden pl-20 md:pl-0', {
          'pr-20 md:pr-0': i === items.length - 1,
        })
      }
      theme="brand"
    >
      {items.map(({ author, date, fullCommentLink, link, onBy, stars, text }) => (
        <TripadvisorTestimony
          author={author}
          className="w-[80vw] md:w-auto"
          date={date}
          fullCommentLink={fullCommentLink}
          key={link.url}
          link={link}
          onBy={onBy}
          stars={stars}
          text={text}
        />
      ))}
    </Slider>
  );
};
